<template>
    <ul class="category-filter">
        <slot name="categories"></slot>
    </ul>
</template>

<script>
    export default {
        name: 'CategoryFilter',
    };
</script>

<style scoped lang="scss">
    @import '~@/assets/styles/abstracts/_variables';

    .category-filter {
        display:    flex;
        flex-direction: column;
        align-items: stretch;
        justify-items: stretch;

        padding:    0;

        list-style: none;

        &__item + &__item {
            margin-top: 0.5rem;
        }

        &__item {
            display: flex;

            justify-content: center;
        }

        &__link {
            width: 100%;
            max-width: 35rem;
        }

        @media screen and (min-width: map_get($grid-breakpoints, 'sm')) {
            flex-direction: row;

            &__item + &__item {
                margin: 0 0 0 2rem;
            }

            &__link {
                width: auto;
            }
        }
    }
</style>
